import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { Image } from 'react-datocms'

import { PROJECT } from '../../env'
import CONFIG from '../../configurator'
import { ProjectList } from '../../utils/constants'

import './Home.scss'

const ModulesList = React.lazy(() => import('../ModulesList'))
const ContentPreview = React.lazy(() => import('../ContentPreview'))
const ExtensionPack = React.lazy(() => import('./ExtensionPack'))
const LessonsListItem = React.lazy(() => import('./LessonsListItem'))

const Home = ({ data, kitsData }) => {
  const { modules, extensions } = data
  const core = data.core || { image: { url: '' }, title: '', text: '' }

  if (CONFIG[PROJECT].single) {
    const currentModule =
      modules.find((module) => {
        return module.kitKind === kitsData.kind
      }) || modules[0]
    if (PROJECT === ProjectList.CONTENTPREVIEW) {
      return <ContentPreview slug={currentModule.slug} />
    } else {
      return <ModulesList slug={currentModule.slug} />
    }
  }

  if (CONFIG[PROJECT].oneList) {
    const moduleList = modules
      .filter((module) => {
        return module.kitKind === kitsData.kind
      })
      .map((currentModule) => {
        return <ModulesList slug={currentModule.slug} key={currentModule.slug} hideList />
      })

    const extensionsList = extensions
      .filter((module) => {
        return module.kitKind === kitsData.kind
      })
      .map((currentModule) => {
        return (
          <ModulesList
            slug={currentModule.slug}
            key={currentModule.slug}
            required={['module', 'projects', '0', 'description']}
            oneList
          />
        )
      })

    return (
      <React.Fragment>
        {moduleList} {extensionsList}
      </React.Fragment>
    )
  }

  const kitsList = [kitsData.kind, ...kitsData.extensions]
  const userRole = kitsData.role

  const coreImage = core.image?.responsiveImage

  return (
    <div className="home main-container">
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .app > .container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
          
          .card-hover-container {
            background:
            linear-gradient(
              180deg,
              rgba(182, 231, 232, 0.61) 0%,
              #9edbdc 46.91%,
              #88d0d1 81.04%,
              #7fcbcd 100%
            )
            ${coreImage ? `,url(${coreImage.src})` : ''};
          }`,
        }}
      />
      {!!modules?.length && modules.length <= 2 && (
        <div className="module-card">
          <div className="card-cover">
            <Image data={{ ...coreImage, alt: 'Arduino' }} />
          </div>
          <div className="card-content">
            <h2>{core.title}</h2>
            <div dangerouslySetInnerHTML={{ __html: core.text }} />
          </div>

          <div className="card-hover-container">
            <div className="card-hover-container-content">
              {modules.map((item, i) => {
                const index = i + 1
                const kind = item.kitKind.toLowerCase()
                return (
                  <div className="card-hover-container-col" key={item.id}>
                    {!CONFIG[PROJECT].hideParts && (
                      <div className="card-hover-container-col-header">
                        {modules.length > 1 && (
                          <Fragment>
                            <FormattedMessage id={'modulePart'} /> {index}
                          </Fragment>
                        )}
                      </div>
                    )}

                    <div className="card-hover-container-col-content">
                      {CONFIG[PROJECT].hideParts ? <h3>{item.title}</h3> : <h3>{item.cardDescription}</h3>}
                      <div dangerouslySetInnerHTML={{ __html: item.introduction }} />
                    </div>
                    <div className="card-hover-container-col-footer">
                      {CONFIG[PROJECT].gibridNavigation ? (
                        <Link
                          to={`/${kind}/module/${item.slug}/lesson/${item.lessons[0]?.slug}`}
                          className="home-round-button">
                          START
                        </Link>
                      ) : (
                        <Link to={`/${kind}/module/${item.slug}`} className="home-round-button">
                          {!CONFIG[PROJECT].hideParts ? (
                            <>
                              <FormattedMessage id={'startPart'} /> {index}
                            </>
                          ) : (
                            'Start'
                          )}
                        </Link>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      )}
      {modules?.length > 2 && (
        <React.Fragment>
          {core.title && <div className="expansion-modules-title">{core.title}</div>}
          <div dangerouslySetInnerHTML={{ __html: core.text }} />
          <div className={`expansion-modules-wrapper ${PROJECT}`}>
            {modules.map((item) => {
              if (item.showOnHomePage) {
                return <ExtensionPack key={item.id} module={item} kitsList={kitsList} userRole={userRole} />
              }
              return null
            })}
          </div>
        </React.Fragment>
      )}
      {!!extensions?.length && (
        <React.Fragment>
          <div className="expansion-modules-title">
            <FormattedMessage id={'moduleExpansion'} />
          </div>
          <div className="expansion-modules-wrapper">
            {extensions.map((item) => {
              if (item.showOnHomePage) {
                if (CONFIG[PROJECT].lessonsList) {
                  const list = item.lessons || []
                  return list.map((lesson) => {
                    return <LessonsListItem key={lesson.id} module={item} lesson={lesson} kitsList={kitsList} />
                  })
                }
                return <ExtensionPack key={item.id} module={item} kitsList={kitsList} userRole={userRole} />
              }
              return null
            })}
          </div>
        </React.Fragment>
      )}
    </div>
  )
}
Home.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func]),
  data: PropTypes.object,
  kitsData: PropTypes.object,
}

export default React.memo(Home)
